import React, { useEffect } from 'react';
import Odometer from 'react-odometerjs';
import 'odometer/themes/odometer-theme-default.css';

const FactArea = () => {
    const facts = [
        { count: 507, suffix: "+", text: "Sessions Conducted" },
        { count: 37, suffix: "+", text: "Industry Experts" },
        { count: 748, suffix: "+", text: "Got Internship" },
        { count: 3.7, suffix: "K+", text: "Students Trained" }
    ];

    useEffect(() => {
        const timer = setTimeout(() => {}, 500);
        return () => clearTimeout(timer);
    }, []);

    return (
        <section className="fact__area mr-t-b-60">
            <div className="container">
                <div className="fact__inner-wrap">
                    <div className="row justify-content-center">
                        {facts.map((fact, index) => (
                            <div className="col-12 col-sm-6 col-md-3 mb-4" key={index}>
                                <div className="fact__item text-center h-100">
                                    <h2 className="count">
                                        <Odometer
                                            value={fact.count}
                                            format="(,ddd).dd"
                                            duration={2000}
                                        />
                                        {fact.suffix}
                                    </h2>
                                    <p>{fact.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FactArea;
